var map = {
	"./一站式大数据平台.jpg": 7141,
	"./合规性自查自纠管理系统.jpg": 8176,
	"./安全运营.jpg": 7723,
	"./数字供应链一站式竞价平台.png": 8793,
	"./智慧园区数智平台.png": 4006,
	"./智能运营.png": 2479,
	"./知识图谱系统.jpg": 8269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6335;